import React, { useEffect, useState } from "react";
import "./Home.css";
import { useTranslation } from "react-i18next";
import JumboContentLayoutMain from "@jumbo/components/JumboContentLayout/JumboContentLayoutMain/JumboContentLayoutMain";
import { Box, Card, CardContent, Grid, Typography, useTheme } from "@mui/material";
import Div from "@jumbo/shared/Div";
import hrApiServices from "app/services/hr-api-services";
import ScrollToTop from "app/pages/ScrollToTop";
import useResponsive from "app/pages/useResponsive";
import ChartOne from "../hr/HrOperation/ChartFile/ChartOne";
import TwoChart from "../hr/HrOperation/ChartFile/TwoChart";
import ThreeChart from "../hr/HrOperation/ChartFile/ThreeChart";
import FourthChart from "../hr/HrOperation/ChartFile/FourthChart";
import { useGetBusinessUnitListQuery } from "app/services/RTK_Apis/dashbords/HomeDefaultApi";


const HomeDashboard = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const token = localStorage.getItem("accesstoken");

  const header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  let isMobile = useResponsive("down", "sm");

  let userDetails = localStorage.getItem("UserDetails");
  userDetails = JSON.parse(userDetails);
  let companyId = userDetails && userDetails.Organization_Id;



  const [partnerLists, setPartnerLists] = useState([{
    id: null, Partner_Name: "All BU"
  }]);
  const [businessUnit, setBusinessUnit] = useState("");
  const [partnerName, setPartnerName] = useState(0);

  const { data: partnerData, isLoading } = useGetBusinessUnitListQuery();

useEffect(() => {
  if (partnerData) {

    const uniqueNames = partnerData.filter(
      newName => !partnerLists.some(prev => prev.id === newName.id)
    );

    const updatedList = [...partnerLists, ...uniqueNames];

    setPartnerLists(updatedList);

    const lastItem = updatedList[updatedList.length - 1];

    setBusinessUnit(lastItem?.Partner_Name);
    setPartnerName(lastItem?.id);

  }
}, [partnerData]);
 


  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={12} sx={{ display: "flex", flexDirection: "column", justifyContent: "top" }}>
          {/* <h3 style={{ cursor: "pointer" }}>
              {t("Welcome to")} <span style={{ fontSize: "26px", fontWeight: 600, color: "#017890 !important" }}> {t(`${userDetails?.first_name} ${userDetails?.last_name}`)}</span>
            </h3> */}
          <Typography variant="h4" fontWeight={500} gutterBottom>
            {t("Welcome")}{" "}
            <Box component="span" color={theme.palette.primary.main} fontWeight={600} fontSize="22px">
              {`${userDetails?.first_name} ${userDetails?.last_name} ${"!"}`}
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={12} lg={12}>
          <Grid container spacing={2}>
            {/* <ChartOne
                    isMobile={isMobile}
                    businessUnit={businessUnit}
                    partnerName={partnerName}
                    companyId={companyId}
                    /> */}
            {[ChartOne, TwoChart, ThreeChart, FourthChart].map((ChartComponent, index) => (
              <Grid item xs={12} lg={6}>
                <Div className="hide-scroll"
                  sx={{
                    p: 3, // padding
                    borderRadius: 3,
                    // minWidth: 360,
                    width: "100%",
                    // minHeight: 360,
                    height: "100%",
                    overflowY: "auto",
                    backgroundColor: "background.paper",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.09)",
                    transition: "box-shadow 0.3s ease",
                    '&:hover': {
                      boxShadow: "0 6px 20px rgba(0, 0, 0, 0.12)",
                    },
                  }}
                >
                  <ChartComponent
                    isMobile={isMobile}
                    businessUnit={businessUnit}
                    partnerName={partnerName}
                    companyId={companyId}
                  />
                </Div>
              </Grid>
            ))}
            {/* <Grid item xs={12} lg={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Div className="p-4 card hide-scroll" sx={{ minWidth: "360px", width: "100%", minHeight: "360px", height: "100%", overflow: "scroll" }}>
                  <TwoChart
                    isMobile={isMobile}
                    businessUnit={businessUnit}
                    partnerName={partnerName}
                    companyId={companyId}
                  />
                </Div>
              </Grid>
              <Grid item xs={12} lg={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Div className="p-4 card hide-scroll" sx={{ minWidth: "360px", width: "100%", minHeight: "360px", height: "100%", overflow: "scroll" }}>
                  <ThreeChart
                    isMobile={isMobile}
                    businessUnit={businessUnit}
                    partnerName={partnerName}
                    companyId={companyId}
                  />
                </Div>
              </Grid>
              <Grid item xs={12} lg={6} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Div className="p-4 card hide-scroll" sx={{ minWidth: "360px", width: "100%", minHeight: "360px", height: "100%", overflow: "scroll" }}>
                  <FourthChart
                    isMobile={isMobile}
                    businessUnit={businessUnit}
                    partnerName={partnerName}
                    companyId={companyId}
                  />
                </Div>
              </Grid> */}
          </Grid>

          <ScrollToTop Scrollheight={220} />
        </Grid>
      </Grid>
      <br />
    </div>
  );
};
export default HomeDashboard;
